<style lang="less" scoped>
.menu-tree {
  margin: 30px 0 0 0;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="角色名称" prop="roleName">
                <el-input v-model="detailForm.roleName" size="small"></el-input>
              </el-form-item>
              <el-form-item label="角色描述" prop="described">
                <el-input
                  type="textarea"
                  v-model="detailForm.described"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="角色归属" prop="roleType">
                <el-radio-group
                  v-model="detailForm.roleType"
                  @change="handleRoleTypeChange()"
                >
                  <el-radio label="02">超管端</el-radio>
                  <el-radio label="03">SaaS端</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="SaaS运营商"
                v-if="detailForm.roleType == '03'"
                prop="dealerNo"
              >
                <el-select
                  class="full-width"
                  v-model="detailForm.dealerNo"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in dealerArr"
                    :label="item.dealName"
                    :value="item.dealNo"
                    :key="index"
                    @click.native="handleDealChange(item.dealName)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="功能权限">
                <!-- <el-tree :data="menuList" class="menu-tree" show-checkbox @check-change="onCheckChange"></el-tree> -->
                <Tree
                  v-if="SaaSFlag"
                  :data="sassMenuList"
                  class="menu-tree"
                  show-checkbox
                  ref="Tree"
                  @on-check-change="onCheckChange"
                ></Tree>
                <Tree
                  v-else
                  :data="adminMenuList"
                  class="menu-tree"
                  show-checkbox
                  ref="Tree"
                  @on-check-change="onCheckChange"
                ></Tree>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item label="按钮权限">
                <Tree
                v-if="SaaSFlag"
                  :data="authMenusList"
                  class="menu-tree"
                  show-checkbox
                  @on-check-change="onSassAuthCheckChange"
                ></Tree>
                <Tree
                v-else
                  :data="adminAuthMenusList"
                  class="menu-tree"
                  show-checkbox
                  @on-check-change="onSassAuthCheckChange"
                ></Tree>
              </el-form-item>
             
               
           
            </div>
             
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageTitle: '角色新增', //标题
      // 默认值设置
      detailForm: {
        roleType: '',
      },
      pageConfig: pageConfig,
      editFlag: false, //是否编辑模式
      SaaSFlag: false, //是否显示已选中的
      sassMenuList: [], //saas端所有菜单列表
      adminMenuList: [], //超管端所有菜单列表
      selMenus: [], //选中的菜单
      selAuths: [], //选中的菜单
      roleMenuList: [], //获取角色菜单
      dealerArr: [], //运营商下拉框
      authMenusList: [], // sass端按钮权限
      adminAuthMenusList: [], // admin端按钮权限
      url:''
    }
  },
  methods: {
    // 菜单列表
    init() {
      this.url = this.$A.role.add;
      if (this.$store.state.editId) {
        this.editFlag = true
        this.pageTitle = '角色编辑'
        this.url = this.$A.role.edit;
        this.getFormInfo()
        this.getRoleMenu(this.$store.state.editId)
      } else {
        this.getMenuList()
      }
      this.getDealer()
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$S.getFormInfo(
        _,
        _.$A.role.list + '/' + _.$store.state.editId,
        function(res) {
          _.detailForm = res.data.data
          _.SaaSFlag = _.detailForm.roleType == '02' ? false : true
          // _.getMenuList()
        }
      )
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      //_.detailForm.roleType= '02';
      _.detailForm.roleTypeName = '4.0_admin'
     
      _.selMenus = []
      //提交的时候获取所有选中的侧边栏权限
      let allMenus = this.$refs.Tree.getCheckedAndIndeterminateNodes()
      console.log(allMenus,444);
      allMenus.forEach((item) => {
        _.selMenus.push(item.id)
      })
      console.log(_.selMenus,222);
      console.log(_.selAuths,111)
      console.log('提交按钮权限')
      console.log('提交所有权限')
      // return false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.detailForm.corpNo = _.$store.state.corpNo
          _.detailForm.roleTypeName =
            _.detailForm.roleType == '02' ? '4.0-admin' : '4.0-saas'
          _.detailForm.menuIds = _.selMenus.concat(_.selAuths)
          _.$S.submitForm(
            _,
            _.url,
            _.editFlag,
            _.detailForm,
            pageConfig.listRouter
          )
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
    // 菜单选择
    onCheckChange(val) {
      this.selMenus = []
      // val.forEach((item) => {
      //   this.selMenus.push(item.id)
      // })
      //获取选中和半选中的值
      let selectMen = this.$refs.Tree.getCheckedAndIndeterminateNodes()
      console.log(selectMen);
      selectMen.forEach((item) => {
        this.selMenus.push(item.id)
      })
      console.log(this.selMenus,555)
    },
    //运营商下拉框
    getDealer() {
      let _ = this
      _.$H.post(_, _.$A.role.saasList, {}).then((res) => {
        _.dealerArr = res.data.data
      })
    },
    // 所有的菜单列表
    getMenuList() {
      console.log('查询~~~~~~~~~~~~')
      var _this = this
      var adminflag = -1
      var sassflag = -1
      var pidNamesObj = {}
      var adminPidNamesObj = {}
      var sassBtnsAuthArr = []
      let sassBtnsAuthObj = {}
      let adminBtnsAuthObj = {}
      _this.$H.post(_this, _this.$A.menu.allList, {}).then(function(res) {
        var dbList = res.data.data
        var sortList = dbList.sort(_this.$U.compare('sort'))
        _this.adminMenuList = []
        _this.sassMenuList = []
        sortList.forEach((item, index) => {
          if (item.targetUrl == 'PILE4_ADMIN'&& '01' == item.menuType) {//超管端权限
            var checked =
              $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false
             console.log(_this.roleMenuList);
            if (item.menuLevel === 1) {
              checked = false
              _this.selMenus.push(item.id)
            }

            if (checked) {
              _this.selMenus.push(item.id)
            }
            let p = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              expand: checked,
              children: [],
              checked: checked,
            }
            // console.log(item);
            if (item.pId === '0' || item.pId === 0) {
              adminflag++
              _this.adminMenuList.push(p)
            } else {
              _this.adminMenuList[adminflag].children.push(p)
            }
            adminPidNamesObj[item.id] = item
            // if (item.parentCode === '' || item.parentCode === null) {
            //   adminflag++
            //   _this.adminMenuList.push(p)
            // } else {
            //   _this.adminMenuList[adminflag].children.push(p)
            // }
          }

          if (item.targetUrl == 'PILE4_SASS' && '01' == item.menuType) { //SasS 端权限
            var checked =
              $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false
            if (item.menuLevel === 1) {
              checked = false
              _this.selMenus.push(item.id)
            }

            if (checked) {
              _this.selMenus.push(item.id)
            }
            let p = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              expand: checked,
              children: [],
              checked: checked,
            }
            if (item.pId === '0' || item.pId === 0) {
              sassflag++
              _this.sassMenuList.push(p)
            } else {
              _this.sassMenuList[sassflag].children.push(p)
            }
            // if (item.parentCode === '' || item.parentCode === null) {
            //   sassflag++
            //   _this.sassMenuList.push(p)
            // } else {
            //   _this.sassMenuList[sassflag].children.push(p)
            // }

            // pidNamesObj[item.menuCode] = item
            pidNamesObj[item.id] = item
          }

          // saas按钮权限
          if (item.targetUrl == 'PILE4_SASS' && '02' == item.menuType) {
            if (sassBtnsAuthObj[item.pId] == undefined) {
              sassBtnsAuthObj[item.pId] = []
            }
            var checked =
              $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false
            let authObj = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              checked: checked,
            }
            sassBtnsAuthObj[item.pId].push(authObj)
            // console.log(sassBtnsAuthObj);
          }
          // admin按钮权限
          if (item.targetUrl == 'PILE4_ADMIN' && '02' == item.menuType) {
            if (adminBtnsAuthObj[item.pId] == undefined) {
              adminBtnsAuthObj[item.pId] = []
            }
            var checked =
              $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false
            let authObj = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              checked: checked,
            }
            adminBtnsAuthObj[item.pId].push(authObj)
            // console.log(sassBtnsAuthObj);
          }
          // if (item.targetUrl == 'PILE4_SASS' && '02' == item.menuType) {
          //   if (sassBtnsAuthObj[item.parentCode] == undefined) {
          //     sassBtnsAuthObj[item.parentCode] = []
          //   }
          //   var checked =
          //     $.inArray(item.id, _this.roleMenuList) >= 0 ? true : false
          //   let authObj = {
          //     title: item.menuNameZh,
          //     id: item.id,
          //     level: item.menuLevel,
          //     pid: item.parentCode,
          //     checked: checked,
          //   }
          //   sassBtnsAuthObj[item.parentCode].push(authObj)
          //   // console.log(sassBtnsAuthObj);
          // }
        })

        let authMenusList = []
        // console.log(pidNamesObj,2222);
        for (let pKey in sassBtnsAuthObj) {
          // console.log(sassBtnsAuthObj[pKey]);
          // console.log(pKey);
          const pObj = pidNamesObj[pKey]
          // console.log(pObj);
          const childArr = sassBtnsAuthObj[pKey]
          const checked = false
          let authMenuObj = {
            title: pObj.menuNameZh,
            id: pObj.id,
            level: pObj.menuLevel,
            pid: pObj.pId,
            children: childArr,
            checked: checked,
          }
          authMenusList.push(authMenuObj)
        }
        _this.authMenusList = authMenusList
        let adminAuthMenusList = []
        // console.log(pidNamesObj,2222);
        for (let pKey in adminBtnsAuthObj) {
          // console.log(sassBtnsAuthObj[pKey]);
          // console.log(pKey);
          const pObj = adminPidNamesObj[pKey]
          console.log(pObj);
          const childArr = adminBtnsAuthObj[pKey]
          const checked = false
          let authMenuObj = {
            title: pObj.menuNameZh,
            id: pObj.id,
            level: pObj.menuLevel,
            pid: pObj.pId,
            children: childArr,
            checked: checked,
          }
          adminAuthMenusList.push(authMenuObj)
        }
        _this.adminAuthMenusList = adminAuthMenusList
        //  console.log('saas权限')
        //   console.log(_this.sassMenuList)
        //   console.log('saas权限')
        //   console.log('admin权限')
          console.log(_this.adminMenuList)
        //   console.log('admin权限')
        //   console.log('按钮权限')
        //   console.log(_this.authMenusList)
        //   console.log('按钮权限')
        //   console.log(_this.adminAuthMenusList)
        //   console.log('admin按钮权限')
        //   console.log('kkkkkkk')
        //   console.log('侧边栏权限')
        //   console.log(_this.selMenus)
        //   console.log('侧边栏权限')
      })
    },
    // 获取角色菜单
    getRoleMenu(roleId) {
      var _this = this
      _this.roleMenuList = []
      var url = _this.$A.role.listmenu
      _this.$H
        .post(_this, url, {
          roleId: roleId,
        })
        .then((response) => {
          response.data.data.forEach((item, index) => {
            _this.roleMenuList.push(item.id)
          })

          // 初始化菜单
          _this.getMenuList()
        })
    },
    //选择角色
    handleRoleTypeChange() {
      if (this.detailForm.roleType == '02') {
        this.SaaSFlag = false
        this.detailForm.dealerName = ''
        this.detailForm.dealerNo = ''
      } else {
        this.SaaSFlag = true
      }
    },
    //选择运营商
    handleDealChange(val) {
      this.detailForm.dealerName = val
    },
    // 按钮选择
    onSassAuthCheckChange(val) {
      this.selAuths = []
      val.forEach((item) => {
        this.selAuths.push(item.id)
      })
      console.log('kkkkkkkkkffff')
      console.log(this.selAuths)
    },
    // // 按钮选择
    // onAdminAuthCheckChange(val) {
    //   console.log(val);
    //   this.selAuths = []
    //   val.forEach((item) => {
    //     this.selAuths.push(item.id)
    //   })
    //   console.log(this.selAuths)
    // },
  },
  mounted() {
    // 面包屑配置
    this.$store.commit('setBreadCrumbList', pageConfig.detailBreadCrumb)
    this.init()
  },
}
</script>
